import { useLayoutEffect, useState } from 'react';
import { useEditorContext } from './useEditorContext';

export const useEditorTextState = () => {
  const { generationText: initialText } = useEditorContext();
  const [text, setText] = useState(initialText);

  useLayoutEffect(() => {
    setText(initialText);
  }, [initialText]);

  return {
    text,
    setText,
  };
};
